var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full px-44 py-32 h-[90%] overflow-y-scroll scroll-hid"},[(_vm.sectionNumber === 1)?_c('div',[_c('about-first')],1):_vm._e(),(_vm.sectionNumber === 2)?_c('div',[_c('about-second')],1):_vm._e(),(_vm.sectionNumber === 3)?_c('div',[_c('about-tres')],1):_vm._e(),(_vm.sectionNumber === 4)?_c('div',[_c('about-four')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }